// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpleHeader_wrapper__o9b4w","spaceBottom":"SimpleHeader_spaceBottom__2IGIu","headline":"SimpleHeader_headline__nxcPd","description":"SimpleHeader_description__GPOO3"};